// Helpers for photo URL manipulation (blur variant) and time formatting.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Given a stored photo URL (which may be absolute or relative), append
 * ?variant=blurred so the backend serves the blurred variant.
 * Non-photo URLs (e.g. external avatars) are returned unchanged.
 */
export const toBlurredUrl = (url) => {
  if (!url) return url;
  // Only /api/photos/{id} URLs support the variant parameter
  if (!url.includes('/api/photos/')) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}variant=blurred`;
};

export const getPrimaryPhoto = (userLike, defaultUrl) => {
  const photos = userLike?.photos || [];
  const idx = userLike?.primary_photo_index ?? 0;
  return photos[idx] || photos[0] || defaultUrl;
};

/**
 * Format a timestamp as "Active 5m ago", "Active 2h ago", "Active 3d ago".
 * Returns null if input is falsy.
 */
export const formatRelativeActive = (isoTimestamp) => {
  if (!isoTimestamp) return null;
  try {
    const then = new Date(isoTimestamp).getTime();
    if (!then) return null;
    const diffMs = Date.now() - then;
    const mins = Math.max(0, Math.floor(diffMs / 60000));
    if (mins < 1) return 'Active now';
    if (mins < 60) return `Active ${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `Active ${hrs}h ago`;
    const days = Math.floor(hrs / 24);
    if (days < 7) return `Active ${days}d ago`;
    const wks = Math.floor(days / 7);
    if (wks < 4) return `Active ${wks}w ago`;
    return null;
  } catch {
    return null;
  }
};

export { BACKEND_URL };
